import polyfills from './polyfills'
import detectTouch from './detectTouch'
import lazyLoad from './lazy-load'
import headerSearch from './header-search'
import headerInit from './header'
import menuInit from './menu'
import mainSlider from './main-slider'
import tabsInit from './tabs'
import itemSlider from './items-slider'
import smallItemSlider from './small-items-slider'
import compositionSlider from './composition-slider'
import accordionInit from './accordion'
import videoSlider from './video-slider'
import modalsListeners from './modals-listeners'
import initModal from './modal'
import catalogFilter from './catalog-filter'
import initForms from  './forms'
import layoutInit from './layout'
import productGallery from './product-gallery'
import recipesSlider from './recipes-slider'
import pickupMap from './pickup-map'
import shareInit from './share'
import historySlider from './history-slider'
import contactsMap from './contacts-map'
import itemTileSlider from './item-tile-slider'
import scrollEvents from './scroll-events'
import tapLink from './tap-hover'
import catalogInit from './catalog'
import viewport from "./viewport";
import wholesaleHeader from './wholesaleHeader';
import wholesaleCatalog from './wholesaleCatalog';
import wholesaleModals from './wholesaleModals';
import './moderniz'

document.addEventListener('DOMContentLoaded', function() {

    layoutInit();

    initForms();

    polyfills();

    detectTouch();

    lazyLoad();

    headerSearch();

    headerInit();

    initModal();

    menuInit();

    mainSlider();

    tabsInit();

    itemSlider();

    accordionInit();

    videoSlider();

    catalogFilter();

    smallItemSlider();

    productGallery();

    recipesSlider();

    pickupMap();

    shareInit();

    historySlider();

    contactsMap();

    itemTileSlider();

    scrollEvents();

    tapLink();

    compositionSlider();

    catalogInit();

    wholesaleHeader();

    wholesaleCatalog();

    wholesaleModals();

    window.frontEndFuncs = {
        catalogFilter: catalogFilter,
        initForms: initForms,
        lazyLoad: lazyLoad,
        catalogInit: catalogInit,
        itemTileSlider: itemTileSlider,
        viewport: viewport,
        itemSlider: itemSlider,
        smallItemSlider: smallItemSlider,
        isDesktop: function () { return viewport().width > 765}
    }
});
